import Header from 'components/organisms/Header';
import Footer from 'components/organisms/Footer';
import Text from 'components/atoms/Text';
import Colors from 'components/tokens/Colors';
import Brand from 'components/atoms/Brand';
import styled from 'styled-components';

function Base({ light, title, children, hidden, contextFooter, dark, link }) {
    const date = new Date();
    const currentYear = date.getFullYear();

    return (
        <>
            <Header light={light} title={title} link={link} />
            {children}
            {contextFooter ? (
                <ContextFooter dark={dark}>
                    <BrandBox dark={dark} />
                    <Text size="12 16" lineHeight="16 22" color={dark ? Colors.primary : Colors.black}>
                        Lupa © {currentYear} Todos os direitos reservados
                    </Text>
                </ContextFooter>
            ) : null}
            <Footer hidden={hidden} />
        </>
    );
}

const BrandBox = ({ dark }) => (
    <a href="/">
        <Brand primary={dark} />
    </a>
);

const ContextFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ dark }) => (dark ? Colors.black : Colors.primary)};
    padding: 40px 24px;
    @media (min-width: 768px) {
        padding: 40px 64px;
    }

    span {
        max-width: 50%;
    }
`;

export default Base;
